export const formatTimeDelta = (minutes?: number) => {
  if (!minutes) {
    return `0min`
  }
  return `${Math.floor(minutes / 60)}h ${minutes % 60}min`
}
